const ERROR_HINTS = [
  {
    match: /private/i,
    icon: "🔒",
    title: "Private account",
    hint: "This account is private. You need to follow it and authenticate instaloader with your session.",
  },
  {
    match: /authentication|login required|auth/i,
    icon: "🔑",
    title: "Login required",
    hint: "Instagram requires authentication. Run: python3 -c \"import instaloader; L=instaloader.Instaloader(); L.interactive_login('YOUR_USERNAME')\" once in the backend folder.",
  },
  {
    match: /rate.?limit|too many|429/i,
    icon: "⏱",
    title: "Rate limited",
    hint: "Instagram is rate-limiting requests. The system will auto-retry 3 times with 10s delays. Try again in a minute.",
  },
  {
    match: /not found|404|does not exist/i,
    icon: "🔍",
    title: "Content not found",
    hint: "The post or profile was not found. Check the URL is correct and the content hasn't been deleted.",
  },
  {
    match: /rate limit.*api|5 request/i,
    icon: "🚦",
    title: "API rate limit",
    hint: "You've hit the server rate limit (5 requests/min). Please wait a moment before trying again.",
  },
  {
    match: /wrong url|invalid url|not an instagram/i,
    icon: "🔗",
    title: "Invalid URL",
    hint: "This doesn't look like an Instagram URL. Paste a link from instagram.com.",
  },
  {
    match: /connection|network|ECONNREFUSED|Lost connection/i,
    icon: "📡",
    title: "Connection error",
    hint: "Can't reach the backend server. Make sure it's running on port 8000.",
  },
];

function getHint(errorMsg) {
  const msg = String(errorMsg || "");
  return ERROR_HINTS.find((h) => h.match.test(msg)) || {
    icon: "⚠️",
    title: "Something went wrong",
    hint: null,
  };
}

export default function ErrorBanner({ error, onDismiss }) {
  if (!error) return null;
  const { icon, title, hint } = getHint(error);

  return (
    <div className="max-w-xl mx-auto animate-fade-in" role="alert">
      <div className="bg-red-500/10 border border-red-500/25 rounded-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center gap-3 px-5 py-4 border-b border-red-500/15">
          <span className="text-xl">{icon}</span>
          <p className="font-semibold text-red-300">{title}</p>
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="ml-auto text-red-400/60 hover:text-red-300 transition-colors text-lg leading-none"
              aria-label="Dismiss"
            >
              ✕
            </button>
          )}
        </div>

        {/* Raw message */}
        <div className="px-5 py-3">
          <p className="text-sm text-red-200/70 font-mono break-words">{error}</p>
        </div>

        {/* Contextual hint */}
        {hint && (
          <div className="px-5 pb-4">
            <p className="text-sm text-[#888] leading-relaxed">{hint}</p>
          </div>
        )}
      </div>
    </div>
  );
}
